module.exports = __webpack_public_path__ + "img/奥康国际.7f748fd9.png";